/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import {showLoading} from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {addDelayProfile, startConcentrating} from '@/businesses/autoProfileBusiness';
import * as APPDATA from '@/constants/pcConstAppData';
import {RunAutoProfileEvent} from '@/constants/pubSubEnum';
import {eventBusObject} from '@/observers/eventBus';

import PreCheckRunningProfile, {PreCheckRunningProfileEvent} from './runProfileValidator/PreCheckRunningProfile';

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
  currentProfileParams: store.setupStore.currentProfileParams,
}))
class RunAutoProfile extends React.Component {
  constructor(props) {
    super(props);

    this._bus = eventBusObject();
    this._bus.subscribe(RunAutoProfileEvent.AUTORUN, (param) => this.runProfileAction(param));
  }

  runProfileAction = () => {
    const {currentProfileParams, dispatch, isPCRunning} = this.props;
    if (currentProfileParams === undefined) {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: 'Please Select a Profile',
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else if (!isPCRunning) {
      dispatch(setupActions.updateStoppingFromButton(false));
      this._bus.publish(PreCheckRunningProfileEvent.RUN_PRE_CHECK, '');
    }
  };

  callBackPreCheckRunningProfile = (params) => {
    const {dispatch} = this.props;

    if (params?.isRunLater) {
      dispatch(showLoading(false));
      dispatch(addDelayProfile(params.startDate, params.relativeTime, params.scheduleType));
    } else {
      dispatch(startConcentrating(params.DeviceElementCheckList));
    }
  };

  render() {
    return <PreCheckRunningProfile callbackReadyToAutoRun={this.callBackPreCheckRunningProfile} />;
  }
}
export default RunAutoProfile;
